const columns = [
    {
        title: 'First Name',
        dataIndex: 'firstName',
        sorter: true,
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        sorter: true,
    },

    {
        title: 'Email',
        dataIndex: 'email',
        sorter: true,
    },
    {
        title: 'Commission',
        dataIndex: 'commissionAmount',
        sorter: true,
    },
    {
        title: 'Action Date',
        dataIndex: 'transactionDate',
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    }
];

export default columns;